import type { RichTranslateFn, TranslateFn } from '@newo/localization';
import type { FC } from 'react';

type ActivateAccountInfoContentProps = {
	translate: TranslateFn;
	rich: RichTranslateFn;
};
const ActivateAccountInfoContent: FC<ActivateAccountInfoContentProps> = ({
	translate,
	rich
}) => {
	return (
		<div className="space-y-4 text-base">
			<p className="text-sm">
				{translate(
					'creator',
					'agent_success.activate_account_info_modal.content.magic'
				)}
			</p>

			<p className="text-sm">
				{translate(
					'creator',
					'agent_success.activate_account_info_modal.content.improvements'
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.free_trial',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.activate_time',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{translate(
					'creator',
					'agent_success.activate_account_info_modal.content.connect_payment'
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.no_risk',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.specialists_training',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.integrations',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.restaurant_case',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.dental_case',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.other_business',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.campaigns',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.next_step',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.cta_instruction',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.schedule_call',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{translate(
					'creator',
					'agent_success.activate_account_info_modal.content.warning'
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.final_reassurance',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>

			<p className="text-sm">
				{rich(
					'creator',
					'agent_success.activate_account_info_modal.content.final_cta',
					{
						strong: (chunk) => <strong>{chunk}</strong>
					}
				)}
			</p>
		</div>
	);
};

export default ActivateAccountInfoContent;
